function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PictureComponent from "components/core/picture/picture-component";
import FullParagraphComponent from "segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import { StyledParagraphAndCarouselReviewsMobileComponent } from "./paragraph-and-carousel-reviews-mobile-component.scss";
export const ParagraphAndCarouselReviewsMobileComponent = (props)=>{
    const { carousel, fullParagraph, mobileMarginBetweenParagraphAndCarousel, removeQuoteSigns } = props;
    const { reviews } = carousel;
    const itemRenderer = (review)=>{
        const { customerImage, name, jobDescription, quote, companyLogo } = review;
        return /*#__PURE__*/ _jsxs("div", {
            className: "review-carousel-item",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "customer-image-wrapper",
                    children: (customerImage === null || customerImage === void 0 ? void 0 : customerImage.src) && /*#__PURE__*/ _jsx(PictureComponent, {
                        className: "customer-image",
                        src: customerImage === null || customerImage === void 0 ? void 0 : customerImage.src,
                        alt: customerImage === null || customerImage === void 0 ? void 0 : customerImage.alt
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "review-card",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "name-and-job-description",
                            children: [
                                name,
                                " | ",
                                jobDescription
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "quote",
                            children: removeQuoteSigns ? quote : `“${quote}“`
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "company-logo-wrapper",
                            children: (companyLogo === null || companyLogo === void 0 ? void 0 : companyLogo.src) && /*#__PURE__*/ _jsx(PictureComponent, {
                                className: "company-logo",
                                src: companyLogo === null || companyLogo === void 0 ? void 0 : companyLogo.src,
                                alt: companyLogo === null || companyLogo === void 0 ? void 0 : companyLogo.alt
                            })
                        })
                    ]
                })
            ]
        });
    };
    const carouselProps = {
        items: reviews,
        itemRenderer,
        defaultIndex: 0,
        infinite: false,
        slidesToShow: 1,
        dots: true,
        autoplaySpeed: 5000,
        centerPadding: "15%"
    };
    return /*#__PURE__*/ _jsxs(StyledParagraphAndCarouselReviewsMobileComponent, {
        className: "paragraph-and-carousel-reviews-mobile-component",
        style: {
            "--margin-between-paragraph-and-carousel": mobileMarginBetweenParagraphAndCarousel
        },
        children: [
            /*#__PURE__*/ _jsx(FullParagraphComponent, _object_spread({}, fullParagraph)),
            /*#__PURE__*/ _jsx("div", {
                className: "carousel-wrapper",
                children: /*#__PURE__*/ _jsx(Carousel, _object_spread({}, carouselProps))
            })
        ]
    });
};
